<template>
  <div>
    <el-card shadow="always">
      <el-button size="small" type="primary" @click="saveDialog()">添加</el-button>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
    </el-card>
    <el-table height="600" size="small" :data="tableData" border :default-expand-all="false" row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="name" label="角色名称" width="180"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="saveDialog(scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <div style="padding: 20px">
        <el-form size="small" ref="formRef" :model="formData" label-width="120px">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="formData.name" style="width: 220px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-but">
        <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'authRole',
  components: {},
  created() {
    this.getData()
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      loading: false,
      tableData: [],
      formData: {
        id: 0,
        name: ''
      }
    }
  },
  methods: {
    async getData() {
      await this.$api.auth.roleList().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ? res.data : []
        }
      })
    },
    // 保存弹窗
    saveDialog(row) {
      this.formData = {
        id: 0,
        name: ''
      }
      this.dialogShow = true
      this.dialogTitle = '添加角色'
      if (row) {
        this.dialogTitle = '编辑角色'
        this.formData = row
      }
    },
    // 保存数据
    async saveData() {
      let data = _.cloneDeep(this.formData)
      this.loading = true
      await this.$api.auth.roleSave(data).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.refresh()
        }
      })
    },
    // 删除数据
    async deleteData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.auth.roleDelete({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.refresh()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 刷新
    refresh() {
      this.getData()
      this.dialogShow = false
    }
  }
}
</script>
